type CompanyTenantLike = {
  companyTenantId?: string;
  name?: string;
};

type SelectOptionLike = { value?: string | null; label?: string } | string | null | undefined;

type ResolveCommercialCompanyNameOptions = {
  companyTenantId?: string | null;
  companyTenants?: CompanyTenantLike[];
  currentName?: SelectOptionLike;
  bookingFormName?: SelectOptionLike;
};

export const resolveCommercialCompanyName = ({
  companyTenantId,
  companyTenants = [],
}: ResolveCommercialCompanyNameOptions): SelectOptionLike => {
  if (!companyTenantId) {
    return "";
  }

  const matchedById = companyTenants.find((item) => item?.companyTenantId === companyTenantId);

  return matchedById?.name ? { value: companyTenantId, label: matchedById.name } : "";
};
